import { PartnerSearchFilterItem } from 'partner360/components/partnerSearchFilter'

/**
 * `PartnerName` is typed as a string but the reports API does return `null` for it,
 * so partners are compared through an empty-string fallback and nameless ones go first.
 */
export const compareByPartnerName = (
  left: PartnerSearchFilterItem,
  right: PartnerSearchFilterItem
) => (left.PartnerName ?? '').localeCompare(right.PartnerName ?? '')
